<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && tender">
			<div class="col-sm-12">
				<div class="row">
					<!-- name -->
					<div class="form-group col-md-4">
						<label>{{ 'tender.name' | translate }}*</label>
						<input
							[(ngModel)]="tender.name"
							#name="ngModel"
							name="name"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'tender.name' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- startdate -->
					<div class="form-group col-md-4">
						<label>{{'tender.startdate' | translate}}*</label>
						<app-datepicker
							[(ngModel)]="tender.startdate"
							name="startdate"
							required
							#startdate="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && startdate.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && startdate.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- stopdate -->
					<div class="form-group col-md-4">
						<label>{{'tender.stopdate' | translate}}*</label>
						<app-datepicker
							[(ngModel)]="tender.stopdate"
							name="stopdate"
							required
							#stopdate="ngModel"
							[min]="tender.startdateasdate"
							[ngClass]="{'is-invalid': editForm.submitted && stopdate.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && stopdate.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- projectdeadline -->
					<div class="form-group col-md-4">
						<label>
							{{'tender.projectdeadline' | translate}}*
						</label>
						<app-datepicker
							[(ngModel)]="tender.projectdeadline"
							name="projectdeadline"
							required
							#projectdeadline="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && projectdeadline.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && projectdeadline.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- microent -->
					<div class="form-group col-md-2">
						<input
							type="checkbox"
							class="form-check-input"
							name="microent"
							[(ngModel)]="tender.microent">
						<label class="form-check-label">{{'tender.microent' | translate}}</label>
					</div>
					<!-- smallent -->
					<div class="form-group col-md-2">
						<input
							type="checkbox"
							class="form-check-input"
							name="smallent"
							[(ngModel)]="tender.smallent">
						<label class="form-check-label">{{'tender.smallent' | translate}}</label>
					</div>
					<!-- mediument -->
					<div class="form-group col-md-2">
						<input
							type="checkbox"
							class="form-check-input"
							name="mediumllent"
							[(ngModel)]="tender.mediument">
						<label class="form-check-label">{{'tender.mediument' | translate}}</label>
					</div>
					<!-- largeent -->
					<div class="form-group col-md-2">
						<input
							type="checkbox"
							class="form-check-input"
							name="largeent"
							[(ngModel)]="tender.largeent">
						<label class="form-check-label">{{'tender.largeent' | translate}}</label>
					</div>
					<!-- description -->
					<div class="form-group col-md-6">
						<label>{{ 'tender.description' | translate }}*</label>
						<textarea
							[(ngModel)]="tender.description"
							#description="ngModel"
							name="description"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'tender.description' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && description.invalid}">
						</textarea>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && description.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- shortdesc -->
					<div class="form-group col-md-6">
						<label>{{ 'tender.shortdesc' | translate }}*</label>
						<textarea
							[(ngModel)]="tender.shortdesc"
							#shortdesc="ngModel"
							name="shortdesc"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'tender.shortdesc' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && shortdesc.invalid}">
						</textarea>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && shortdesc.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- minproject -->
					<div class="form-group col-md-3">
						<label>
							{{'tender.minproject' | translate}} (€)*
						</label>
						<input
							type="number"
							class="form-control"
							name="minproject"
							[(ngModel)]="tender.minproject"
							required
							#minproject="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && minproject.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && minproject.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- maxproject -->
					<div class="form-group col-md-3">
						<label>
							{{'tender.maxproject' | translate}} (€)*
						</label>
						<input
							type="number"
							class="form-control"
							name="maxproject"
							required
							#maxproject="ngModel"
							[(ngModel)]="tender.maxproject"
							[ngClass]="{'is-invalid': editForm.submitted && maxproject.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && maxproject.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- mincontribution -->
					<div class="form-group col-md-3">
						<label>
							{{'tender.mincontribution' | translate}} (%)*
						</label>
						<input
							type="number"
							class="form-control"
							name="mincontribution"
							[(ngModel)]="tender.mincontribution"
							required
							#mincontribution="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && mincontribution.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && mincontribution.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- maxcontribution -->
					<div class="form-group col-md-3">
						<label>
							{{'tender.maxcontribution' | translate}} (%)*
						</label>
						<input
							type="number"
							class="form-control"
							name="maxcontribution"
							[(ngModel)]="tender.maxcontribution"
							required
							#maxcontribution="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && maxcontribution.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && maxcontribution.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- minlength -->
					<div class="form-group col-md-3">
						<label>{{'tender.minlength' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="minlength"
							[(ngModel)]="tender.minlength"
							required
							#minlength="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && minlength.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && minlength.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- maxlength -->
					<div class="form-group col-md-3">
						<label>{{'tender.maxlength' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="maxlength"
							[(ngModel)]="tender.maxlength"
							required
							#maxlength="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && maxlength.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && maxlength.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

				</div>
				<div class="row">
					<!-- costi -->
					<div class="col-md-12">{{'tender.costsflags' | translate}}</div>
					<div class="col">
						<div class="form-check">
							<input
								type="checkbox"
								class="form-check-input"
								name="hrresources"
								[(ngModel)]="tender.hrresources">
							<label class="form-check-label">{{'tender.hrresources' | translate}}</label>
						</div>
					</div>
					<div class="col">
						<div class="form-check">
							<input
								type="checkbox"
								class="form-check-input"
								name="tools"
								[(ngModel)]="tender.tools">
							<label class="form-check-label">{{'tender.tools' | translate}}</label>
						</div>
					</div>
					<div class="col">
						<div class="form-check">
							<input
								type="checkbox"
								class="form-check-input"
								name="buildings"
								[(ngModel)]="tender.buildings">
							<label class="form-check-label">{{'tender.buildings' | translate}}</label>
						</div>
					</div>
					<div class="col">
						<div class="form-check">
							<input
								type="checkbox"
								class="form-check-input"
								name="othercosts"
								[(ngModel)]="tender.othercosts">
							<label class="form-check-label">{{'tender.othercosts' | translate}}</label>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
